import { Microfrontend } from './Microfrontend';
export class DefaultMicrofrontend extends Microfrontend {
    constructor(tag) {
        super({ tag, version: '*0.0.1' });
    }
}
